const useSetShareButtons = () => {
  const handleShareButton = (post: IGetPostDetail) => {
    if (navigator.share) {
      navigator.share({
        url: window.location.href,
        title: post?.title,
      });
    } else {
    }
  };
  return {handleShareButton};
};

export default useSetShareButtons;
